import { useState } from "react";
import PaginationUI from "../atoms/PaginationUI";
import ColumnButton from "../molecules/ColumnButton";
import ColumnLabels from "../molecules/ColumnLabels";
import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
import ColumnText from "../molecules/ColumnText";
import ColumnTitleDate from "../molecules/ColumnTitleDate";
import LoadTable from "./LoadTable";

export type userRecoveryProps = {
  name: string;
  image: string;
  email: string;
};

export type informationPaymentProps = {
  date: string;
  title: string;
  description: string;
};

export type RecoveryPageProps = {
  id: number;
  name: string;
  avatar: string;
  email: string;
  branch: {
    branch: string;
    gym: {
      gym: string;
    };
  };
  state_fee: {
    date_finish: string;
    method: string;
    fee: {
      name: string;
    };
  };
  tasks: string;
  user_tags: string[];
  marketing_tags: string[];
  tickets: any[];
  payments: string[];
  incidents: string[];
  followNote: string;
};

export type TableListRecoveryProps = {
  people: RecoveryPageProps[];
  openIncidence: (id: number) => void;
  loader: boolean;
};

const TableListRecovery: React.FC<TableListRecoveryProps> = ({
  people,
  openIncidence,
  loader,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  if (loader) {
    return <LoadTable />;
  }

  const totalResults = people?.length || 0;
  const totalPages = Math.ceil(totalResults / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentPeople = people.slice(startIndex, startIndex + pageSize);

  return (
    <div className="px-4 sm:px-6 lg:px-0">
      <div className="mt-2 flow-root ">
        <div className="-mx-4 -my-2 overflow-x-auto overflow-y-hidden sm:-mx-6 lg:-mx-8 max-h-[65dvh]">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 ">
            <div className="overflow-y-auto max-h-[65dvh]">
              <table className="min-w-full divide-y divide-gray-300  px-4 ">
                <thead>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Usuario
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Compañía & Filial
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Información de pago
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Tipo de pago
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Cuotas
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Nota de seguimiento
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Etiquetas usuario
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Etiquetas marketing
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Incidencia
                  </th>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {currentPeople.map((person) => {
                    const hasTickets = person?.tickets?.length > 0;

                    return (
                      <tr key={person?.id}>
                        <ColumnPersonInformationAvatar
                          name={person?.name}
                          image={
                            person?.avatar ??
                            "https://dash.fitmewise.com/uploads/users/profile.png"
                          }
                          id={person?.id}
                          email={person?.email}
                          open_user={true}
                        />
                        <ColumnText
                          title={`${person?.branch?.gym?.gym}/${person?.branch?.branch}`}
                        />
                        <ColumnTitleDate
                          title={"Con retraso"}
                          date={person?.state_fee?.date_finish}
                        />
                        <ColumnText
                          title={
                            person?.state_fee?.method === "cash"
                              ? "Efectivo"
                              : "Efectivo y con retraso"
                          }
                        />
                        <ColumnText title={person?.state_fee?.fee?.name} />
                        <ColumnText title={person?.followNote} />
                        <ColumnLabels labels={person?.user_tags} />
                        <ColumnLabels labels={person?.marketing_tags} />
                        {hasTickets ? (
                          <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                            <button
                              onClick={() =>
                                openIncidence(person?.tickets?.[0])
                              }
                              className="text-primary-600 hover:text-primary-900 cursor-pointer"
                            >
                              Ver incidencia
                            </button>
                          </td>
                        ) : null}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-shrink-0">
        <PaginationUI
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          pageSize={pageSize}
          totalResults={totalResults}
        />
      </div>
    </div>
  );
};

export default TableListRecovery;

{
  /* <div className="px-4 sm:px-6 lg:px-0 overflow-hidden">
    <div className="mt-2 flow-root ">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full  py-2 align-middle sm:px-6 lg:px-8 ">
          <div className="overflow-y-auto max-h-full">
            <table className="min-w-full divide-y divide-gray-300  px-4 ">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Usuario
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Compañía & Filial
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Información de pago
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Tipo de pago
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Cuotas
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Nota de seguimiento
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Etiquetas usuario
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Etiquetas marketing
                  </th>
                  <th
                    scope="col"
                    className="sticky top-0 z-10 border-b border-gray-300 bg-white py-3.5 px-3 text-left text-sm font-semibold text-gray-900 shadow-md"
                  >
                    Incidencia
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {currentPeople.map((person) => (
                  <tr key={person?.id}>
                    <ColumnPersonInformationAvatar
                      name={person?.name}
                      image={
                        person?.avatar ??
                        "https://dash.fitmewise.com/uploads/users/profile.png"
                      }
                      id={person?.id}
                      email={person?.email}
                      open_user={true}
                    />
                    <ColumnText
                      title={`${person?.branch?.gym?.gym}/${person?.branch?.branch}`}
                    />
                    <ColumnTitleDate
                      title={"Con retraso"}
                      date={person?.state_fee?.date_finish}
                    />
                    <ColumnText
                      title={
                        person?.state_fee?.method === "cash"
                          ? "Efectivo"
                          : "Efectivo y con retraso"
                      }
                    />
                    <ColumnText title={person?.state_fee?.fee?.name} />
                    <ColumnText title={person?.followNote} />
                    <ColumnLabels labels={person?.user_tags} />
                    <ColumnLabels labels={person?.marketing_tags} />
                    <td>
                      {person?.tickets?.length > 0 && (
                        <ColumnButton
                          name="Ver incidencia"
                          action={() => openIncidence(person?.tickets?.[0])}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <PaginationUI
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
        pageSize={pageSize}
        totalResults={totalResults}
      />
    </div>
  </div>
); */
}
